import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import $ from "../../utils/jquery";
import feather from "feather-icons";
import {logoutUser} from '../../api/web';
import PerfectScrollbar from 'perfect-scrollbar';
import {useDispatch, useSelector} from "react-redux";
import {capitalize} from "../../utils/capitalize";

const Header = () => {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth.user) || {};

    const [menu, set_menu] = useState({
        dashboard: "nav-item",
        user: "nav-item",
        scheme: "nav-item",
        scheme_application: "nav-item",
        input_delivery: "nav-item",
        preseason_contract: "nav-item",
        trade_offer: "nav-item",
        sell_request: "nav-item",
        product: "nav-item",
        activity: "nav-item"
    });

    const onLogoutClick = (event) => {
        event.preventDefault();
        dispatch(logoutUser());
    };

    //detect url change and update it.
    useEffect(() => {
        let url = window.location.hash.split("/").pop();
        Object.keys(menu).forEach(function(key){ set_menu((prevState) => ({
            ...prevState,
            [key]: "nav-item",
            [url]: "nav-item active"
        }))});
    }, [window.location.hash.split("/").pop()])

    useEffect(() => {
        $(function () {
            'use strict';
            feather.replace();

            const asideBody = new PerfectScrollbar('.aside-body', {
                suppressScrollX: true
            });

            if($('.aside-backdrop').length === 0) {
                $('body').append('<div class="aside-backdrop"></div>');
            }

            var mql = window.matchMedia('(min-width:992px) and (max-width: 1199px)');

            function doMinimize(e) {
                if (e.matches) {
                    $('.aside').addClass('minimize');
                } else {
                    $('.aside').removeClass('minimize');
                }

                asideBody.update()
            }

            mql.addListener(doMinimize);
            doMinimize(mql);

            $('.aside-menu-link').on('click', function(e){
                e.preventDefault();

                if(window.matchMedia('(min-width: 992px)').matches) {
                    $(this).closest('.aside').toggleClass('minimize');
                } else {

                    $('body').toggleClass('show-aside');
                }

                asideBody.update()
            });

            $('.nav-aside .with-sub').on('click', '.nav-link', function(e){
                e.preventDefault();

                $(this).parent().siblings().removeClass('show');
                $(this).parent().toggleClass('show');

                asideBody.update()
            });

            $('body').on('mouseenter', '.minimize .aside-body', function(e){
                $(this).parent().addClass('maximize');
            });

            $('body').on('mouseleave', '.minimize .aside-body', function(e){
                $(this).parent().removeClass('maximize');

                asideBody.update()
            });

            $('body').on('click', '.aside-backdrop', function(e){
                $('body').removeClass('show-aside');
            })
        });
    }, []);

    return (
        <aside className="aside aside-fixed">
            <div className="aside-header">
                <a href="#" className="aside-logo">Muli<span>mi</span></a>
                <a href="#" className="aside-menu-link">
                    <i data-feather="menu"></i>
                    <i data-feather="x"></i>
                </a>
            </div>
            <div className="aside-body">
                <div className="aside-loggedin">
                    <div className="aside-loggedin-user">
                        <button
                            type="button"
                            className="btn btn-link d-flex align-items-center justify-content-between mg-b-2 pd-0 w-100 tx-left"
                            data-bs-toggle="collapse"
                            data-bs-target="#loggedinMenu"
                            aria-expanded="false"
                            aria-controls="loggedinMenu"
                        >
                            <h6 className="tx-semibold mg-b-0">{user ? capitalize(user.username) : ''}</h6>
                            <i data-feather="chevron-down"></i>
                        </button>
                        <p className="tx-color-03 tx-12 mg-b-0">Company Rep</p>
                        <button
                            type="button"
                            onClick={onLogoutClick}
                            className="btn btn-sm btn-outline-secondary mg-t-10 d-inline-flex align-items-center"
                        >
                            <i data-feather="log-out" className="mg-r-5"></i>
                            <span>Sign Out</span>
                        </button>
                    </div>
                    <div className="collapse" id="loggedinMenu">
                        <ul className="nav nav-aside mg-b-0">
                            <li className="nav-item"><Link to="#" onClick={onLogoutClick.bind()} className="nav-link"><i data-feather="log-out"></i>
                                <span>Sign Out</span></Link></li>
                        </ul>
                    </div>
                </div>

                <ul className="nav nav-aside">
                    <li className="nav-label">Menu</li>
                    <li className={menu.dashboard}><Link to="/dashboard" className="nav-link"><i data-feather="file-text"></i> <span>Dashboard</span></Link></li>
                    <li className={menu.scheme}><Link to="/scheme" className="nav-link"><i data-feather="book-open"></i> <span>Schemes</span></Link></li>
                    <li className={menu.user}><Link to="/user" className="nav-link"><i data-feather="user-plus"></i> <span>Users</span></Link></li>
                    <li className={menu.scheme_application}><Link to="/scheme_application" className="nav-link"><i data-feather="file"></i> <span>Scheme Applications</span></Link></li>
                    <li className={menu.input_delivery}><Link to="/input_delivery" className="nav-link"><i data-feather="truck"></i> <span>Input Deliveries</span></Link></li>
                    <li className={menu.preseason_contract}><Link to="/preseason_contract" className="nav-link"><i data-feather="clipboard"></i> <span>Preseason Contracts</span></Link></li>
                    <li className={menu.trade_offer}><Link to="/trade_offer" className="nav-link"><i data-feather="shopping-cart"></i> <span>Trade Offers</span></Link></li>
                    <li className={menu.sell_request}><Link to="/sell_request" className="nav-link"><i data-feather="dollar-sign"></i> <span>Sell Requests</span></Link></li>
                    <li className={menu.product}><Link to="/product" className="nav-link"><i data-feather="package"></i> <span>Products</span></Link></li>

                    <li className="nav-label mg-t-25">Settings</li>
                    <li className={menu.activity}><Link to="/activity" className="nav-link"><i data-feather="activity"></i> <span>Activity</span></Link></li>
                </ul>
            </div>
        </aside>
    );
};

export default Header;
